import { useProfile } from './useProfile/index.jsx';

export function useIsDemoEnv() {
  const { getProfileField } = useProfile();
  const isDemoEnv = getProfileField('config')?.demoEnvironment;

  return !!isDemoEnv;
}
